import { render } from "./KampagneView.vue?vue&type=template&id=716bcfd4"
import script from "./KampagneView.vue?vue&type=script&lang=js"
export * from "./KampagneView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__